module.exports = __webpack_public_path__ + "img/border2.2e03805d.png";